<template>
  <div class="box-viewmore">
    <div v-if="title" class="title-box v-line">
      <h2>{{ title }}</h2>
    </div>
    <div class="" ref="box" :class="!isHidden ? 'box-content-hidden' : 'box-content'">
      <slot id="content" />
    </div>
    <div class="flex justify-center">
      <button
        class="btn-viewmore mr-0"
        :class="open ? 'btn-open' : 'btn-close'"
        @click="openView()"
        v-if="isHidden"
      >
        <span>{{ getExpandLabel }}</span>
        <i
          :class="['icon text-primary', { rotate: !this.open }, iconClassName]"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    title: {
        type: String,
        default: '',
    },
    iconClassName: {
        type: String,
        default: 'icon-bor-triangle-down',
    }
  },
  data() {
    return {
      open: true,
      isHidden: true
    }
  },
  mounted() {
    this.getHeight()
  },
  computed: {
    getExpandLabel() {
      return this.open ? '詳細を見る' : '閉じる'
    }
  },
  methods: {
    getHeight() {
      const heightOfBox = this.$refs.box.clientHeight
      if (heightOfBox < 30) {
        this.isHidden = false
      } else {
        this.isHidden = true
      }
    },
    openView() {
      this.open = !this.open
      this.$emit('open', this.open)
    }
  },
  updated() {
    this.getHeight()
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
